"use client"
import { motion, AnimatePresence } from "framer-motion";
import styles from "./STTextAnimationFlip.module.css";
import { useEffect, useState } from "react";
import clsx from "clsx";
const defaultTexts = ["Truly circular", "PFAS free", "Microplastic free", "Bio-based"];

export const STTextAnimationFlip = ({
  className,
  texts = defaultTexts,
  subTitle = "materials",
}) => {
  const activeTexts =
    Array.isArray(texts) && texts.filter(Boolean).length > 0
      ? texts.filter(Boolean)
      : defaultTexts;

  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setDirection(1); // slide up
      setIndex((prev) => (prev + 1) % activeTexts.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [activeTexts.length]);

  const variants = {
    enter: (direction) => ({
      y: direction > 0 ? "100%" : "-100%",
      opacity: 0,
    }),
    center: {
      y: "0%",
      opacity: 1,
    },
    exit: (direction) => ({
      y: direction > 0 ? "-100%" : "100%",
      opacity: 0,
    }),
  };

  const currentText = activeTexts[index % activeTexts.length] || activeTexts[0];

  return (
    <>
      <div className={clsx(styles.animation, className)}>
        <motion.div
          layout
          className={clsx(
            styles.animateText,
            "position-relative overflow-hidden text-white fw-normal lh-base bg-blue",
          )}
        >
          <AnimatePresence custom={direction} mode="popLayout" initial={false}>
            <motion.div
              key={currentText}
              custom={direction}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ duration: 0.5 }}
              layout
            >
              {currentText}
            </motion.div>
          </AnimatePresence>
        </motion.div>
        <motion.h1 layout className="mb-0 text-white fw-normal lh-base">
          {subTitle || "materials"}
        </motion.h1>
      </div>
    </>
  );
};